import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=0c474cb6&scoped=true"
import script from "./landingpage.vue?vue&type=script&setup=true&lang=js"
export * from "./landingpage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./landingpage.vue?vue&type=style&index=0&id=0c474cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c474cb6",
  null
  
)

export default component.exports